<form [formGroup]="mainForm" (ngSubmit)="onSubmit()">
    <div fxLayout="row" fxLayoutAlign="center center" class="banner">
        <span class="forge-typography--headline">
            Please login with your pre-existing user credentials to connect your email with your user
            account.
            <br>
            <br>
            You will only need to do this once.
        </span>
    </div>

    <lgd-text controlName="username" label="Username">
    </lgd-text>

    <lgd-password controlName="password" label="Password">
    </lgd-password>

    <div class="login-button-container" fxLayout="column" fxLayoutAlign="space-between center">
        <forge-button type="submit" variant="raised" [disabled]="submitDisabled">
            <span *ngIf="!loading; else busy">Sign in</span>
        </forge-button>

        <forge-button *ngIf="showForgotPwLink" [disabled]="forgotPasswordDisabled" (click)="SwitchToForgotPassword()">
            Forgot password
        </forge-button>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" class="error">
        <label class="error-text forge-typography--subheading1">
            {{error}}
        </label>
    </div>
</form>

<ng-template #busy>
    <forge-circular-progress diameter="30">
    </forge-circular-progress>
</ng-template>
